// @flow
import * as React from 'react';
import * as R from 'ramda';
import EditorCloseIcon from '@atlaskit/icon/glyph/editor/close';

import {
  Flex,
} from 'chronos-styled';

import type {
  FilterOption,
  Filters,
  FilterType,
} from 'chronos-types';

import {
  FiltersList,
  FilterItem,
  TypeName,
} from './styled';


type Props = {
  /**
   * Already selected filters.
   * */
  selectedFilters: Filters,
  /**
   * Function that is called after remove filter.
   * */
  onRemove: { ({ selectedType: FilterType, option: FilterOption }): void },
};

const FilterSelectedList = ({
  selectedFilters,
  onRemove,
}: Props) => {
  const selectedFiltersGroupedByType = (
    R.groupBy(
      i => i.selectedType.label,
      selectedFilters,
    )
  );
  return (
    <>
      {Object.keys(selectedFiltersGroupedByType).map(
        type => (
          <FiltersList key={type}>
            <Flex padding="4px 16px">
              <TypeName>
                Selected
                {' '}
                {type}
              </TypeName>
            </Flex>
            {selectedFiltersGroupedByType[type].map(f => (
              <FilterItem
                key={f.option.value}
                onClick={() => {
                  onRemove({
                    selectedType: f.selectedType.value,
                    option: f.option,
                  });
                }}
              >
                <EditorCloseIcon
                  size="small"
                  label="remove"
                />
                {f.option.label}
              </FilterItem>
            ))}
          </FiltersList>
        ),
      )}
    </>
  );
};

export default FilterSelectedList;
